// extracted by mini-css-extract-plugin
export default {"link":"TJ-z","disabled":"UJ-z"};